import { FormDetails } from './form_details'
import { FormDetail } from './form_detail'

export { FormDetails, FormDetail }
